function animateMenuIcon() {
    const btn = $( ".nav-btn" )
    const nav = $( ".main-navigation" )

    function toggleMenu( open ) {
        btn.toggleClass( "open", open )
        nav.toggleClass( "open", open )
        $( "body" ).toggleClass( "menu-open", open )
        btn.attr( "aria-expanded", open )
        nav.attr( "aria-hidden", !open )
    }

    btn.on( "click", function() {
        toggleMenu( !btn.hasClass( "open" ) )
    })

    nav.on( "click", "a", function() {
        toggleMenu( false )
    })

    $( document ).on( "keydown", function( e ) {
        if ( e.key === "Escape" && btn.hasClass( "open" ) ) {
            toggleMenu( false )
        }
    })
}

$(document).ready( function() {
    animateMenuIcon()
})
